export type ToastType = "success" | "error";

export type ToastPayload = {
    id: string;
    message: string;
    type: ToastType;
    duration: number;
};

export const TOAST_EVENT = "gym-system-toast";

const showToast = (message: string, type: ToastType) => {
    if (typeof window === "undefined") return;

    const payload: ToastPayload = {
        id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        message,
        type,
        duration: 3000,
    };

    window.dispatchEvent(new CustomEvent<ToastPayload>(TOAST_EVENT, { detail: payload }));
};

export const showSuccessToast = (message: string) => showToast(message, "success");

export const showErrorToast = (message: string) => showToast(message, "error");
